export enum DashboardTemplateTypes {
	SYSTEM = 'SYSTEM',
	CUSTOM = 'CUSTOM'
}